module.exports = __webpack_public_path__ + "static/distanciamento_img-0429e01032520348c39c369c652baf92.jpg";